import styled from 'styled-components';

export const TaskTime = styled.div`
  min-width: 40px;
  text-align: left;
`;

export const TaskTimeLabel = styled.h6`
  font-size: 14px;
  font-weight: 500;
  color: var(--clr-title);
  line-height: 21px;
`;

export const TaskTimeDuration = styled.span`
  font-size: 11px;
  color: var(--clr-general-description);
  line-height: 17px;
  font-weight: 400;
`;

export const TaskCardWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: flex-start;
  background-color: var(--tag-red);
  border-radius: 5px;
  padding: 10px;
  border: 1px solid var(--clr-error-border);
  &.is-completed {
    background-color: var(--clr-container-bg);
    border-color: var(--clr-border-grey-100);
  }
`;

export const TaskTitle = styled.div`
  font-weight: 500;
  font-size: 13px;
  color: var(--clr-title);
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TaskMatter = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  .icon {
    font-size: 14px;
    color: var(--clr-general-description);
    flex-shrink: 0;
  }
`;

export const TaskUser = styled(TaskMatter)``;
